// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"47e74129","498":"8ec1b36c","703":"e6ebb7b8","787":"7aa6bf2e"}[chunkId] + ".chunk.js";
};